import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { useTranslation } from "@/core/i18n";
import { Notification, useNotify } from "atoms/notification";

const CloseBrowserPaymentUpdatedPage = () => {
  const { t } = useTranslation();
  const [notificationProps, notify] = useNotify();
  const [searchParams] = useSearchParams();
  const successfulPayment = searchParams.get("successfulPayment");

  useEffect(() => {
    if (successfulPayment === "true") {
      notify.success(t("closeBrowserPaymentUpdatedPage.updateSuccess"), {
        timeout: 5000,
        dismissable: false,
      });
    } else if (successfulPayment === "false") {
      notify.error(t("closeBrowserPaymentUpdatedPage.updateFailure"), {
        timeout: 5000,
        dismissable: false,
      });
    }
  }, [successfulPayment, notify, t]);

  return (
    <div className="flex h-full flex-col items-center justify-center">
      <div className="mb-2">
        <Notification {...notificationProps} />
      </div>
      <div className="text-body1">{t("closeBrowserPaymentUpdatedPage.closeBrowser")}</div>
    </div>
  );
};

export default CloseBrowserPaymentUpdatedPage;
